import { OptionItem } from 'app/components/display-selected-options/display-selected-options';
import { FieldItem } from 'app/area/reports/types';
import { TargetPanelTexts } from './components/target-panel';

export const getTargetSelectedOption = (
  selctedField: FieldItem,
  translation: TargetPanelTexts
): OptionItem => {

  return {
    value: 'target',
    label: translation.target_title,
    selections: {
      titles: [],
      values: [selctedField.description],
      excludedValues: []
    }
  };
};
